import React, { useState, useEffect } from "react";
import {
  Box,
  InputAdornment,
  Typography,
  TextField,
  Button,
  Modal,
  Grid,
  useMediaQuery,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import { apiList, invokeApi } from "../services/apiServices";
import { config } from "../config/config";

const AutoPopup = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleOpenPopup();
    }, 15000);
    return () => clearTimeout(timer);
  }, []);

  const handleOpenPopup = () => {
    const formSubmitted = sessionStorage.getItem("formSubmitted") === "yes";
    if (!formSubmitted) {
      setOpen(true);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const name = formData.name.trim();
    const phone = formData.phone.trim();

    if (!name || !phone) {
      alert("Please fill both Name and Phone Number.");
      return;
    }

    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.addLead,
        formData
      );

      if (response?.status === 200) {
        sessionStorage.setItem("formSubmitted", "yes");
        alert("Thank you! Our property expert will contact you soon.");
        setOpen(false);
        setFormData({ name: "", phone: "" });
      } else {
        console.error("Failed to send data:", response);
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "calc(100% - 20px)", sm: "300px", md: "400px" },
          bgcolor: "background.paper",
          border: "2px solid #018f87",
          boxShadow: 24,
          borderRadius: 2,
          p: isMobile ? 3 : 4,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 1,
            textAlign: "center",
            fontWeight: "bold",
            color: "#018f87",
          }}
        >
          Book a Free Property Visit
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            textAlign: "center",
            fontSize: "15px",
            color: "#444",
          }}
        >
          Schedule a free site visit and explore your dream property with our
          real estate experts.
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 3,
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            required
            id="name"
            label="Full Name"
            variant="outlined"
            fullWidth
            value={formData.name}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{ fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
            inputProps={{ style: { height: "8px", fontSize: 14 } }}
          />

          <TextField
            required
            id="phone"
            label="Phone Number"
            variant="outlined"
            fullWidth
            value={formData.phone}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIcon style={{ fontSize: 18 }} /> +91
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 10,
              style: { height: "8px", fontSize: 14 },
            }}
          />

          <Button
            variant="contained"
            fullWidth
            type="submit"
            startIcon={<SendIcon />}
            sx={{ mt: 1, backgroundColor: "#018f87" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AutoPopup;
